// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JBJR","footer":"styles_footer__3fGQO","passCodeTooltip":"styles_passCodeTooltip__2jTgn"};